import creator from "./creator";
import select from "./select";

export default function(name) {
  return select(creator(name).call(document.documentElement));
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-selection/src/create.js
// module id = 9jWo
// module chunks = 0